<template>
    <span class="caozuoshouce">
        <template v-if="title">
            <el-button type="text" @click="openShouCe()"> {{title}}</el-button>
        </template>
        <template v-else>
            <el-button type="danger" class="shouceBtn" @click="openShouCe()" size="mini"> 不会填写点这里： 填写指南</el-button>
        </template>

        <el-dialog title="指南列表" :visible.sync="shouceDialog" top="20px" width="520px" append-to-body>
            <el-table
                    :data="shouceList"
                    border
                    :height="screenHeight - 187"
                    style="width: 100%">
                <el-table-column label="序号" type="index" width="50" fixed align="center"></el-table-column>
                <el-table-column label="指南列表">
                    <template slot-scope="scope">
                        <el-button type="text" @click="downloadShouCe(scope.row)">{{scope.row.name}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </span>
</template>
<script>
    import baseUrl from "../constants";

    export default {
        props: ['title'],
        data() {
            return {
                screenHeight: document.documentElement.clientHeight, // 可见区域高度(应为body高度，可某些环境下无法获取)
                shouceDialog: false,
                shouceList: [
                    {name: "市场监管总局关于调整实施强制管理的计量器具目录的公告.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-CT.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-水表.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-加气机.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-加油机.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-焦度计.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-镜片箱.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-压力表.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-验光仪.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-电能表.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-燃气表.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-热能表.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-心电图.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-血压计.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-脑电图.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-声级计.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-体温计.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-电子计价秤.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-电子汽车衡.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-谷物容重器.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-雷达测速仪.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-电磁流量计.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-气体流量计.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-汽车充电桩.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-多参数监护仪.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-出租车计价器.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-谷物水分测定仪.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-呼出气体酒精含量检测仪.pdf", url: ""},
                    {name: "强检计量器具台账器具信息填写指南-数字X射线摄影（DR）系统X射线辐射源.pdf", url: ""},
                ],
            }
        },
        methods: {
            //打开操作手册
            openShouCe(){
                this.shouceDialog = true;
            },
            downloadShouCe(row){
                window.open(baseUrl + "/file/download?file=/shoucePDF/" + row.name + "&name=" + row.name, '_blank');
            },
        },
    }
</script>

<style lang="scss" scoped>
    .caozuoshouce {
        .shouceBtn {
            background-color: #ff4949;
            border-style: outset;
            border-width: 3px;
            border-radius: 7px;
            vertical-align: middle;
        }
    }
</style>
